export default __webpack_public_path__ + "static/media/DMA-Icon.cccb326b.svg";